<template>
  <div class="row">
    <div class="container-fluid">
      <div class="row server-list">
        <server-card v-for="server in serversAll" :key="server.id" :server="server"/>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import ServerCard from "./List/ServerCard";

export default {
  components: {ServerCard},
  mounted () {
    this.serverFetchList();
    this.licenseFetchList();
  },
  computed: {
    ...mapGetters(['serversAll']),
  },
  data: function () {
    return {}
  },
  methods: {
    ...mapActions(['serverFetchList', 'licenseFetchList'])
  }
}
</script>
<style>
.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Servers/List.vue